var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCutlery(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 39,
    viewBox: "0 0 39 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8 6.54102C10.08 6.54102 9.6 7.26102 9.6 7.74102V13.741H7.2V7.74102C7.2 7.02102 6.72 6.54102 6 6.54102C5.28 6.54102 4.8 7.26102 4.8 7.74102V13.741H2.4V7.74102C2.4 7.02102 1.92 6.54102 1.2 6.54102C0.48 6.54102 0 7.26102 0 7.74102V15.661C0 17.821 1.68 19.501 3.6 19.741V36.541C3.6 37.981 4.56 38.941 6 38.941C7.44 38.941 8.4 37.981 8.4 36.541V19.741C10.32 19.501 12 17.821 12 15.661V7.74102C12 7.26102 11.52 6.54102 10.8 6.54102ZM15.6 7.74102V22.141H18V36.541C18 37.981 18.96 38.941 20.4 38.941C21.84 38.941 22.8 37.981 22.8 36.541V0.541016C18.72 0.541016 15.6 3.66102 15.6 7.74102ZM32.4 5.34102C29.04 5.34102 26.4 8.94102 26.4 13.261C26.16 16.141 27.6 18.781 30 20.461V36.541C30 37.981 30.96 38.941 32.4 38.941C33.84 38.941 34.8 37.981 34.8 36.541V20.461C37.2 18.781 38.64 16.141 38.4 13.261C38.4 8.94102 35.76 5.34102 32.4 5.34102Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCutlery);
export default __webpack_public_path__ + "static/media/cutlery.e3b0c1b81af6b37dd523c0741b20d2aa.svg";
export { ForwardRef as ReactComponent };